import { render, staticRenderFns } from "./FieldTable.vue?vue&type=template&id=1aa2a2b5"
import script from "./FieldTable.vue?vue&type=script&lang=js"
export * from "./FieldTable.vue?vue&type=script&lang=js"
import style0 from "./FieldTable.vue?vue&type=style&index=0&id=1aa2a2b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports